import React, { FC, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classNames from 'classnames';

import { PUSH_TIMEOUT } from '../../constants';
import { clearPush } from '../../store/actions/app';
import { RootState } from '../../types';

import {
  CloseIcon,
  DefaultIcon,
  ErrorIcon,
  SuccessIcon,
  WarningIcon,
} from './icons';

import './push.scss';

const Push: FC = () => {
  const dispatch = useDispatch();
  const { message, type } = useSelector((state: RootState) => state.app.push);
  const [visible, setVisible] = useState(false);
  let timer: number | null;
  let localMessage = '';

  const clearTimer = () => {
    timer && clearTimeout(timer);
    timer = null;
  };

  useEffect(() => setVisible(!!message), [message]);

  const handleClearPush = () => {
    dispatch(clearPush());
    setVisible(false);
  };

  useEffect(() => {
    timer = window.setTimeout(handleClearPush, PUSH_TIMEOUT);
    return () => clearTimer();
  }, []);

  useEffect(() => {
    if (message && message !== localMessage) {
      localMessage = message;
      clearTimer();
      timer = window.setTimeout(handleClearPush, PUSH_TIMEOUT);
    } else if (!message && localMessage) {
      clearTimer();
    }
  });

  const icon = useMemo(() => {
    switch (type) {
      case 'warning':
        return <WarningIcon />;
      case 'error':
        return <ErrorIcon />;
      case 'success':
        return <SuccessIcon />;
      default:
        return <DefaultIcon />;
    }
  }, [type]);

  return (
    <div
      className={classNames('push', `push--${type}`, {
        'push--visible': visible,
      })}
    >
      <div className="push__body">
        {icon}
        <span className="push__text">{message}</span>
      </div>

      <button type="button" onClick={handleClearPush}>
        <CloseIcon />
      </button>
    </div>
  );
};

export default Push;
